import { render, staticRenderFns } from "./page2part5.vue?vue&type=template&id=000938ff&scoped=true"
import script from "./page2part5.vue?vue&type=script&lang=js"
export * from "./page2part5.vue?vue&type=script&lang=js"
import style0 from "./page2part5.vue?vue&type=style&index=0&id=000938ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000938ff",
  null
  
)

export default component.exports